import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';

@NgModule({

  imports: [
    RouterModule,
    CommonModule,
    HttpClientModule,
    DialogModule,
    TableModule
  ],
  declarations: [
    ],
  exports: [
    RouterModule,
    CommonModule,
    HttpClientModule,
    DialogModule,
    TableModule
  ],
  providers: [
    DialogService,
  ]
})
export class SharedModule {
}
